import { ApiService } from "@core/api/api-service";
import { HasVeevaRecordInput, VeevaUserRecordData } from "@domain/veeva/veeva";

export class VeevaService {
	constructor(private readonly masterAxiosApiService: ApiService) {}

	async getVeevaUserData(veevaId: string): Promise<VeevaUserRecordData> {
		const result = await this.masterAxiosApiService.get<VeevaUserRecordData>(`/veeva/search/${veevaId}`);
		return result.data;
	}

	async hasVeevaRecord(params: HasVeevaRecordInput): Promise<boolean> {
		const result = await this.masterAxiosApiService.get<HasVeevaRecordOutput>("/veeva/exists", { params });
		return result.data.hasVeevaRecord;
	}
}

interface HasVeevaRecordOutput {
	hasVeevaRecord: boolean;
}
